import { AbstractDrawPolygon } from "../abstract-draw-polygon";

export class MeasureDrawPolygon extends AbstractDrawPolygon {

}
